import React, { useEffect, useState } from 'react';
import SeatingPlanGenerate from './SeatingPlanGenerate';
import KenDialogBox from '../../../../../global_components/KenDialogBox';
import KenButton from '../../../../../global_components/KenButton';
import { Grid, IconButton, Typography } from '@material-ui/core';
import SeatingplanInput from './SeatingplanInput';
import EditIcon from '@material-ui/icons/Edit';
import KenSelect from '../../../../../global_components/KenSelect';
import SwapHorizontalCircleIcon from '@material-ui/icons/SwapHorizontalCircle';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import './index.scss';
import {
  seatingPlanStudentDataList,
  seatingPlanUpdate,
} from '../../../../../Utils/apiServices';
import KenDialog from '../../../../../global_components/KenDialogBox';

const idGenerater = () => {
  let id = Math.random().toString(36).substr(2, 9);
  return id;
};

const MainSeatingPlan = ({
  roomChoosen,
  roomDropdown,
  interCandidateSpacing,
  eligibleStudentList,
  setRoomChoosen,
  array3D,
  setArray3D,
  edit,
}) => {
  const [facilityName, setFacilityName] = useState(roomDropdown[0].value);
  const [studentList, setStudentList] = useState(eligibleStudentList);
  const [studentRollNo, setStudentRollNo] = useState([]);

  // Static InputDetails

  // const [array3D, setArray3D] = useState([]);

  const [selectedFacilityData, setSelectedFaciltyData] = useState();
  const [studentSwap, setStudentSwap] = useState('');

  useEffect(() => {
    if (facilityName) {
      const chosenRoomData = roomDropdown.find(
        (el) => el.facilityId === facilityName
      );
      setSelectedFaciltyData(chosenRoomData);
    }
  }, [facilityName]);

  console.log(facilityName, selectedFacilityData);

  useEffect(() => {
    const data = studentList?.sort((a, b) => {
      if (a.columnNumber !== b.columnNumber) {
        return a.columnNumber - b.columnNumber;
      }
      if (a.rowNumber !== b.rowNumber) {
        return a.rowNumber - b.rowNumber;
      }
      if (a.seatNumber !== b.seatNumber) {
        return a.seatNumber - b.seatNumber;
      }
      return 0;
    });

    const studentListOptions = [];
    studentList?.forEach((item) => {
      if (item.rollNumber != null) {
        studentListOptions.push({
          label: item.rollNumber,
          value: item.rollNumber,
        });
      }
    });
    setStudentRollNo(studentListOptions);

    let a = data
      ?.filter((obj) => obj.seatNumber !== null)
      ?.map((obj) => obj.rollNumber);

    let arr3D = [];

    // let arrayIndex = 0;
    // let seating_start_point = 0;
    // let Intercandidate_spacing = 1;

    let indexStudent = 0;
    let studentDataCopy = [...studentList];
    for (let index = 0; index < roomChoosen.length; index++) {
      for (let i = 0; i < roomChoosen[index].noOfColumns; i++) {
        let arr2D = [];
        for (let j = 0; j < roomChoosen[index].noOfRows; j++) {
          let arr1D = [];
          for (let k = 0; k < roomChoosen[index]?.seatsPerBench; k++) {
            let seatno = k + 1;

            arr1D.push({
              ...studentDataCopy[indexStudent],
              facilityName: roomChoosen[index]?.facilityName,
              facilityId: roomChoosen[index]?.facilityId,
              seatNumber: seatno,
              columnNumber: i + 1,
              rowNumber: j + 1,
              studentListOptions: studentListOptions,
              selectedStudent: studentDataCopy[indexStudent]?.rollNumber,
              isSwap: false,
            });
            console.log(arr1D);
            if (interCandidateSpacing > 0) {
              for (let m = 1; m <= interCandidateSpacing; m++) {
                arr1D.push({
                  facilityName: roomChoosen[index]?.facilityName,
                  facilityId: roomChoosen[index]?.facilityId,
                  rollNumber: null,
                  seatNumber: seatno + m,
                  columnNumber: i + 1,
                  rowNumber: j + 1,
                  studentListOptions: null,
                  selectedStudent: null,
                });
              }
              k++;
            }

            indexStudent++;
            // setStudentLastIndex(indexStudent);
          }
          arr2D.push(arr1D.slice(0, roomChoosen[index]?.seatsPerBench));
        }
        arr3D.push(arr2D);
      }
    }

    setArray3D(arr3D);
  }, [studentList, interCandidateSpacing]);

  console.log(array3D, studentRollNo);

  let arr1Ds = array3D?.map((arr2D) => arr2D?.flat());

  console.log(arr1Ds);

  const onFacilityChange = (e) => {
    setSelectedFaciltyData(
      roomChoosen.find((el) => el.facilityId === e.target.value)
    );
    setFacilityName(e.target.value);
  };

  console.log(selectedFacilityData, studentSwap);

  const onSwapStudentEdit = (value, z) => {
    setArray3D((prev) => {
      return prev?.map((item) => {
        return item?.map((data) => {
          return data?.map((qq) => {
            if (value.rollNumber === qq.rollNumber) {
              return {
                ...qq,
                isSwap: true,
              };
              // setSwap(true);
            } else {
              return qq;
            }
          });
        });
      });
    });
  };

  const getSeatsOccupied = () => {
    let num = 0;
    array3D.flat(2).map((el) => {
      if (
        selectedFacilityData?.facilityId === el?.facilityId &&
        el?.rollNumber != null
      ) {
        num = num + 1;
      }
    });
    return num;
  };

  const onSwapStudentHandle = (value, z) => {
    const selectedstudentname = value.rollNumber;
    setArray3D((prev) => {
      return prev?.map((item) => {
        return item?.map((data) => {
          return data?.map((qq) => {
            if (value.rollNumber === qq.rollNumber) {
              return {
                ...qq,
                rollNumber: studentSwap,
                isSwap: false,
              };
            } else if (studentSwap === qq.rollNumber) {
              return {
                ...qq,
                rollNumber: selectedstudentname,
              };
            } else {
              return qq;
            }
          });
        });
      });
    });
  };

  {
    return (
      <div
        style={{
          marginTop: '30px',
          padding: '20px',
          background: '#FEFEFE',
          borderRadius: '8px',
        }}
      >
        <SeatingplanInput
          roomDropdown={roomDropdown}
          facilityName={facilityName}
          roomChoosen={roomChoosen}
          setSelectedFaciltyData={setSelectedFaciltyData}
          onFacilityChange={onFacilityChange}
          setRoomChoosen={setRoomChoosen}
          selectedFacilityData={selectedFacilityData}
        ></SeatingplanInput>
        <Grid
          style={{ marginTop: '50px' }}
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid xs={4} md={4} sm={4} style={{ display: 'flex', justifyContent: 'flex-start' }}>
            {' '}
            <div
              style={{ color: ' #000', fontSize: '30px' }}
              class="material-icons"
            >
              event_seat
            </div>{' '}
            <div
              // style={{
              //   fontSize: '15px',
              //   marginLeft: '10px',
              //   // marginRight: '200px',
              //   marginRight: '-207x',
              //   marginTop: '5px',
              // }}
            >
              Seat Occupied({getSeatsOccupied()})
            </div>
          </Grid>
          {/* <Grid xs={4} style={{ display: 'flex', justifyContent: 'end' }}>
            {' '}
            <div
              style={{ color: 'rgb(182 182 182)', fontSize: '30px' }}
              class="material-icons"
            >
              event_seat
            </div>{' '}
            <div
              style={{
                fontSize: '15px',
                marginLeft: '10px',
                marginTop: '5px',
              }}
            >
              Vacant Seat
            </div>
          </Grid> */}
        </Grid>
        <div
          style={{
            width: '100%',
            overflow: 'auto',
            maxHeight: '500px',
            border: '1px solid',
            marginTop:'32px'
          }}
        >
          <table style={{ width: '100%' }}>
            <tbody style={{ display: 'flex' }}>
              {array3D?.map((arr2D, x) => (
                <tr
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderRight: '1px dotted',
                  }}
                  key={x}
                >
                  {arr2D?.map((arr1D, y) => (
                    <td
                      key={y}
                      style={{
                        padding: 10,
                        display: 'flex',
                        marginRight: '20px',
                        marginLeft: '20px',
                      }}
                    >
                      {arr1D?.map((value, z) => {
                        return (
                          <>
                            {selectedFacilityData?.facilityId ==
                              value?.facilityId && (
                              <div
                                style={
                                  Object.keys(value).length === 0
                                    ? {
                                        border: '1px solid #000',
                                        borderRadius: '4px',
                                        margin: '5px',
                                      }
                                    : value.rollNumber !== null
                                    ? {
                                        border: '1px solid #000',
                                        margin: '5px',
                                        borderRadius: '4px',
                                      }
                                    : {
                                        border: '1px solid #e3e3e3',
                                        borderRadius: '4px',
                                        margin: '5px',
                                      }
                                }
                                // className="main-div-seat"
                                key={z}
                              >
                                <div
                                  style={
                                    Object.keys(value).length === 0
                                      ? {
                                          width: '90px',
                                          height: '100px',
                                          margin: '3px',
                                          borderRadius: '3px',
                                          textAlign: 'center',
                                        }
                                      : value?.rollNumber !== null &&
                                        value?.studentRecordId !== undefined
                                      ? {
                                          width: '90px',
                                          height: '100px',
                                          margin: '3px',
                                          borderRadius: '3px',
                                          textAlign: 'center',
                                        }
                                      : {
                                          width: '90px',
                                          height: '100px',
                                          margin: '3px',
                                          background: '#e3e3e3',
                                          borderRadius: '3px',
                                          textAlign: 'center',
                                        }
                                  }
                                >
                                  <div
                                    style={{ paddingTop: '5px' }}
                                    class="material-icons"
                                  >
                                    event_seat
                                  </div>
                                  <div style={{ fontSize: '12px' }}>
                                    {value.isSwap &&
                                    edit === true &&
                                    value.rollNumber !== null ? (
                                      <KenSelect
                                        optionalLabel={false}
                                        options={value?.studentListOptions}
                                        value={value?.rollNumber}
                                        onChange={(e, data) => {
                                          setStudentSwap(e.target.value);
                                        }}
                                        style={{ fontSize: 12 }}
                                      />
                                    ) : (
                                      value.rollNumber
                                    )}
                                  </div>
                                  <div>
                                    {Object.keys(value).length !== 0 &&
                                      value.rollNumber !== null &&
                                      value.studentRecordId !== undefined &&
                                      (value.isSwap && edit === true ? (
                                        <IconButton
                                          style={{
                                            padding: '0px',
                                            marginTop: '12px',
                                          }}
                                          onClick={() => {
                                            onSwapStudentHandle(value, z);
                                          }}
                                        >
                                          <CheckCircleIcon />
                                        </IconButton>
                                      ) : (
                                        <>
                                          {edit === true && (
                                            <IconButton
                                              style={{
                                                padding: '0px',
                                                marginTop: '12px',
                                              }}
                                              onClick={() => {
                                                onSwapStudentEdit(value, z);
                                              }}
                                            >
                                              <SwapHorizontalCircleIcon />
                                            </IconButton>
                                          )}
                                        </>
                                      ))}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        );
                      })}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
};

export default MainSeatingPlan;
